const mutations = {
  setActiveMenu (state, menuKey) {
    state.activeMenu = menuKey
  },
  setAccounts (state, accounts) {
    state.accounts = accounts
  },
  setAccountsError (state, accountsError) {
    state.accountsError = accountsError
  },
  setNebPay (state, nebPay) {
    state.nebPay = nebPay
  },
  setUser (state, user) {
    state.user = user
  },
  setNeedSingUp (state, needSingUp) {
    state.needSingUp = needSingUp
  },
  setDappAddress (state, dappAddress) {
    state.dappAddress = dappAddress
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js